import { createStyles, makeStyles } from "@material-ui/core";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "components/TextField";
import React from "react";

const useStyles = makeStyles(() =>
  createStyles({
    autocomplete: {
      "& > div .MuiInputBase-root.MuiOutlinedInput-root": {
        height: "auto",
      },
    },
  })
);

interface AutocompleteProps {
  label: string;
  options: any[];
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  name?: string;
  placeholder?: string;
  [key: string]: any;
}

export default function Autocomplete({
  label,
  options,
  fullWidth,
  error,
  required,
  name,
  helperText,
  placeholder,
  ...props
}: AutocompleteProps) {
  const styles = useStyles();
  return (
    <MuiAutocomplete
      {...props}
      options={options}
      data-testid="mui-autocomplete"
      className={styles.autocomplete}
      renderInput={(params) => (
        <>
          <TextField
            style={{
              backgroundColor: props?.disabled ? "#ececec" : "#fff",
            }}
            name={name}
            helperText={helperText}
            error={error}
            required={required}
            fullWidth={fullWidth}
            {...params}
            label={label}
            placeholder={placeholder}
            variant="outlined"
          />
        </>
      )}
    />
  );
}
